// selectedCountySlice.js
import { createSlice } from '@reduxjs/toolkit';

export const selectedCountySlice = createSlice({
  name: 'selectedCounty',
  initialState: {
    countySlug: null, // Renamed from 'value' to 'countySlug'
  },
  reducers: {
    setSelectedCountySlug: (state, action) => {
      state.countySlug = action.payload; // Update the state with the new slug
    },
  },
});

export const { setSelectedCountySlug } = selectedCountySlice.actions;
export default selectedCountySlice.reducer;
